import { getTemplatesByID, SuperTooltipTemplateId } from './generated';
import { SuperTooltipTemplate } from './types';

type SuperTooltipModelParams = {
  templateId: SuperTooltipTemplateId;
};

export const useSuperTooltipModel = ({
  templateId,
}: SuperTooltipModelParams): { content: SuperTooltipTemplate[] } => {
  return {
    content: getTemplatesByID(templateId),
  };
};
